import { useQuery } from '@tanstack/react-query'
import { getTransaction } from './api'

export const transactionQueryKey = (id: string) => ['transactions', id] as const

export function useTransaction(id: string | undefined) {
  return useQuery({
    queryKey: ['transactions', id ?? ''] as const,
    queryFn: () => getTransaction(id!),
    enabled: id !== undefined && id !== '',
    // Detail view is investigation-state — keep it hot but don't block on
    // refocus; analysts often switch tabs between this and the alert detail.
    staleTime: 60_000,
  })
}
